import { Route, Routes, Navigate } from "react-router-dom";

import { MasterLayout } from "@/../_metronic/layout/MasterLayout";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { PermissionEnum } from "@/utils/enums/PermissionEnum";

import { UsersManagement } from "@/pages/app/UsersManagement";
import { Restrict } from "@/components/Restrict";
import { Home } from "@/pages/app/Home";
import { InstitutionalPlataform } from "@/pages/app/InstitutionalPlatform";
import { Personal } from "@/pages/app/Personal";
import { Player } from "@/pages/app/InstitutionalPlatform/TrackList/Player";
import { ReleaseNotesManagement } from "@/pages/app/ReleaseNotesManagement";
import { FederalUnitEsusRoutes } from "./FederalUnitEsusRoutes";
import { CityEsusRoutes } from "./CityEsusRoutes";
import { CitySIntegradaRoutes } from "./CitySIntegradaRoutes";
import { AdminRoutes } from "./AdminRoutes";

const PrivateRoutes = () => {
	const { isLoading, user, uf, ibgeCode, module } = useCurrentAccount();
	if (isLoading) {
		return (
			<Routes>
				<Route path="*" element={<></>} />
			</Routes>
		);
	} else if (!user?.identifier || user?.isLocked) {
		return (
			<Routes>
				<Route path="*" element={<Navigate to="/error/401" />}></Route>
			</Routes>
		);
	}

	function getModuleRoutes(module?: number, uf?: string, ibgeCode?: string) {
		const isFederalUnitAccess = uf && !ibgeCode;
		const isCityAccess = uf && ibgeCode;
		if (isCityAccess) {
			if (module === 1) {
				return (
					<>
						<CityEsusRoutes />
						<AdminRoutes />
					</>
				);
			} else if (module === 2) {
				return (
					<>
						<CitySIntegradaRoutes />
						<AdminRoutes />
					</>
				);
			} else {
				return (
					<>
						<CityEsusRoutes />
						<CitySIntegradaRoutes />
						<AdminRoutes />
					</>
				);
			}
		} else if (isFederalUnitAccess) {
			return (
				<>
					<FederalUnitEsusRoutes />
					<AdminRoutes />
				</>
			);
		}
		return (
			<>
				<AdminRoutes />
			</>
		);
	}

	return (
		<Routes>
			<Route path="/selecao-de-unidade" element={<Navigate to="/" />} />
			<Route element={<MasterLayout />}>
				<Route path="/auth/*" element={<Navigate to="/selecao-de-unidade" />} />
				<Route path="/home" element={<Home />} />
				<Route path="/Perfil" element={<Personal />} />
				<Route path="*" element={getModuleRoutes(module, uf, ibgeCode)} />
				<Route
					path="/ambiente-de-apoio/acesso-a-plataforma"
					element={<InstitutionalPlataform />}
				/>
				<Route
					path="/ambiente-de-apoio/acesso-a-plataforma/tracks/:trackListId/video/:sequence"
					element={<Player />}
				/>

				<Route
					path="/gestao-de-profissionais"
					element={
						<Restrict
							permissions={[
								PermissionEnum.ESUS_VIEW_PROFESSIONAL_MANAGEMENT,
								PermissionEnum.ESUS_STATE_PROFESSIONAL_MANAGEMENT,
								PermissionEnum.SINTEGRADA_PROFESSIONAL_MANAGEMENT,
							]}
							redirectIfNotAuthorized
						>
							<UsersManagement />
						</Restrict>
					}
				/>

				<Route path="/versoes" element={<ReleaseNotesManagement />} />

				{/* Page Not Found */}

				<Route path="*" element={<Navigate to="/error/404" />} />
			</Route>
		</Routes>
	);
};

export { PrivateRoutes };
